

























































































import Vue, { PropType } from 'vue';
import {
  Option,
  options,
  Story,
} from 'mostra';

export type DataType = {
  designDisplayTypes: Option;
};

export default Vue.extend({
  name: 'GImageDescriptionForm',
  props: {
    index: { type: Number as PropType<number>, default: 0 },
    // designDisplayTypes: {
    //   type: Array as PropType<Option>,
    //   required: true,
    // },
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    story: {
      type: Object as PropType<Story[]>,
      required: true,
    },
  },
  data(): DataType {
    return {
      designDisplayTypes: options.storyImageDescriptionTypes,
    };
  },
});
